import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  signatures: [],
}

const getters = {
  signatures(airlines) {
    let url = `/AnserData?`
    if (airlines && airlines.length > 0) {
      airlines.forEach((airline, index) => {
        url +=
          index === 0
            ? `airlines=${airline.icaoCode}`
            : `&airlines=${airline.icaoCode}`
      })
    }

    return axios.get(url)
  },
}

export default class AnserService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
